// extracted by mini-css-extract-plugin
export default {"main":"style_main__7C6i4","subTitle":"style_subTitle__u0XC0","text":"style_text__UeeBE"};